import { injectable, interfaces } from 'inversify';
import { action, makeObservable, observable } from 'mobx';
import { InputStatus } from '../../../../../../__legacy__/models/error.model';
import { AnnotationToolType } from '../../../../../../__legacy__/modules/annotation/submodules/annotationTypes/models/annotationToolType';
import { MarkingTool } from '../commons/models/MarkingTool';

export interface IAddMarkingToolStore {
  readonly name: string;
  readonly nameStatus: InputStatus;
  readonly projectId: string;
  readonly showModal: boolean;
  readonly toolType: AnnotationToolType;
  readonly color: string;
  setName(name: string): void;
  setNameStatus(nameStatus: InputStatus): void;
  setShowModal(showModal: boolean): void;
  setToolType(toolType: AnnotationToolType): void;
  setColor(color: string): void;
  setupStore(projectId: string): void;
}

export namespace IAddMarkingToolStore {
  export const $: interfaces.ServiceIdentifier<IAddMarkingToolStore> = Symbol('ADD_MARKING_TOOL_STORE');
}

@injectable()
export class AddMarkingToolStoreImpl implements IAddMarkingToolStore {
  name: string = '';

  nameStatus: InputStatus = InputStatus.valid();

  showModal: boolean = false;

  toolType: AnnotationToolType = AnnotationToolType.RECTANGLE;

  color: string = '';

  projectId: string = '';

  constructor() {
    makeObservable(this, {
      name: observable,
      nameStatus: observable,
      showModal: observable,
      toolType: observable,
      color: observable,
      setupStore: action,
    });
  }

  setName(name: string): void {
    this.name = name;
  }

  setNameStatus(nameStatus: InputStatus): void {
    this.nameStatus = nameStatus;
  }

  setShowModal(showModal: boolean): void {
    this.showModal = showModal;
  }

  setToolType(toolType: AnnotationToolType): void {
    this.toolType = toolType;
  }

  setColor(color: string): void {
    this.color = color;
  }

  setupStore(projectId: string): void {
    this.setMarkingTool(MarkingTool.empty());
    this.projectId = projectId;
    this.nameStatus = InputStatus.empty();
    this.showModal = true;
  }

  private setMarkingTool(markingTool: MarkingTool): void {
    this.name = markingTool.name;
    this.color = markingTool.color;
    this.toolType = markingTool.selectorType;
  }
}
